/**
 * @fileoverview Auth endpoint service for system-web — owns api.auth.* calls.
 * @module system-web/services/authService
 *
 * Responsibilities: - Wrap /api/auth/* endpoints so pages/hooks never import apiClient.
 * Dependencies:     - ../apiClient (api.auth)
 * Architecture:     - Inherently online — session tokens cannot be served from Dexie.
 * Notes:            - Only the endpoints consumed by UI are wrapped here; add more
 *                     api.auth.* wrappers as pages adopt them.
 */

import { api } from '../apiClient';

/**
 * @process createDepartmentSessionToken
 * Purpose: Mint a session token for entering a specific department after the
 *          Entra-authenticated user picks one on the auth callback page —
 *          inherently online.
 * Steps:    1. POST /api/auth/create-session-token.
 * Inputs:   { entraUserId, email, departmentSlug }.
 * Outputs:  { sessionToken } — used to build the tenant-web redirect URL.
 * Failure Handling: Throws on non-OK HTTP; caller shows the error and stops.
 * Idempotency: NOT REQUIRED — each call mints a fresh token.
 */
export async function createDepartmentSessionToken(data: {
  entraUserId: string;
  email: string;
  departmentSlug: string;
}): Promise<{ sessionToken: string }> {
  return api.auth.createSessionToken(data);
}
